import React, { useState } from "react";
import "@styles/pages/GenericPage/FaqPage.scss";
import { Box, Typography } from "@mui/material";
import AccordionRow from "@components/ui/AccordionRow";
import { Trans, useTranslation } from "react-i18next";

const FaqPage = () => {
  const { t } = useTranslation();

  const [openIndex, setOpenIndex] = useState(null);

  const faqList = Array.from({ length: 14 }, (_, i) => {
    const idx = i + 1;
    return {
      question: t(`faq:${idx}_question`),
      answer: t(`faq:${idx}_answer`),
    };
  });

  return (
    <Box className="faq-container">
      <Typography className="title">
        <Trans i18nKey="faq:faq_title" />
      </Typography>
      {faqList.map((item, index) => (
        <AccordionRow
          iconType="plusminus"
          key={index}
          summaryTitle={index + 1 + ". " + item.question}
          isOpen={openIndex === index}
          onToggle={() => setOpenIndex(openIndex === index ? null : index)}
          details={[
            {
              value: (
                <Typography
                  dangerouslySetInnerHTML={{
                    __html: item.answer,
                  }}
                />
              ),
            },
          ]}
        />
      ))}
    </Box>
  );
};

export default FaqPage;
